import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../session-storage/session-storage.service';
import { environment } from '../../../../environments/environment';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class OtpVerificationService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  // Email Verify OTP
  async otpVerification(otp: string) {
    const API_URL: string = environment.baseUrl + environment.apis.verifyOtp;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        'email': this.sessionStorageService.getCurrentUserEmail(),
        'userotp': otp
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  // Request OTP Mail.
  async requestOtp() {
    const API_URL: string = environment.baseUrl + environment.apis.sendOtp;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        'useremail': this.sessionStorageService.getCurrentUserEmail()
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  // Resend Email OTP
  async resendOtp() {
    const API_URL: string = environment.baseUrl + environment.apis.login;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        'username': this.sessionStorageService.getCurrentUserEmail(),
        'password': this.sessionStorageService.getCurrentUserPassword()
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

}
